import { Popover } from 'antd'

const PopoverComponent = ({ title, description, name, color, placement = 'top' }) => {
  return (
    <Popover
      placement={placement}
      color={color}
      content={
        <>
          <strong>
            {title}{' '}
          </strong>
          <span>
            {description}
          </span>
        </>
      }
      overlayInnerStyle={{ width: 300 }}
    >
      <a>{name}</a>
    </Popover>
  )
}

export default PopoverComponent
